/**
 * Partners component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Image from '../image/image';

export default class Partners extends PureComponent {

	render() {

		const { items } = this.props;
		
		if (items.length && items[0].name) {

			return (

				<ul className="list list-matrix list-clients mt-9">
					{
						items.map((item, i) => {

							return <li key={'list-' + i}><Image data={item.logo} classes="contain lazyloaded"/></li>
						})
					}
				</ul>
			)
		}
		else {
	
			return null;			
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/partners/partners.js